const Email_Regex = /^\w+([.+-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,20})+$/;
export const handleValidationLogin = (user, isOtp) => {
    let isValid = true;
    let message = '';
    if (isOtp) {
        if (!user.emailId) {
            message = 'Email cannot be empty';
            isValid = false;
        } else if (!user.emailId.match(Email_Regex)) {
            message = 'Email not valid';
            isValid = false;
        }
        return { isValid, message };
    } else {
        if (!user.emailId) {
            message = 'Email cannot be empty';
            isValid = false;
        } else if (!user.emailId.match(Email_Regex)) {
            message = 'Email not valid';
            isValid = false;
        } else if (!user.password) {
            message = 'Password cannot be empty';
            isValid = false;
        } else if (user.password.includes(' ')) {
            message = 'Password cannot contain space';
            isValid = false;
        }
        return {
            isValid,
            message,
        };
    }
};
export const handleCerberusValidationLogin = (user) => {
    let isValid = true;
    let message = '';
    if (!user.emailId) {
        message = 'Email cannot be empty';
        isValid = false;
    } else if (!user.emailId.match(Email_Regex)) {
        message = 'Email not valid';
        isValid = false;
    }
    return {
        isValid,
        message,
    };
};

export const handleValidationSignup = (user) => {
    let isValid = true;
    let message = '';
    if (!user.name || !user.name.trim().length) {
        message = 'Full Name cannot be empty';
        isValid = false;
    } else if (!user.name.match(/^[A-Za-z\s]+$/)) {
        message = 'Full Name can only contain letters';
        isValid = false;
    } else if (user.name.length < 3) {
        message = 'Full Name too short';
        isValid = false;
    } else if (user.name.length > 30) {
        message = 'Full Name too long';
        isValid = false;
    } else if (!user.organization || !user.organization.trim().length) {
        message = 'Company Name cannot be empty';
        isValid = false;
    } else if (user.organization.length < 3) {
        message = 'Company Name too short';
        isValid = false;
    } else if (user.organization.length > 150) {
        message = 'Company Name too long';
        isValid = false;
    } else if (!user.mobileNumber) {
        message = 'Contact No cannot be empty';
        isValid = false;
    } else if (user.mobileNumber.length !== 10) {
        message = 'Contact No should be 10 digits number';
        isValid = false;
    } else if (!user.mobileNumber.match(/^[0-9]+$/)) {
        message = 'Contact No can only contain digits';
        isValid = false;
    } else if (!user.emaiId) {
        message = 'Email cannot be empty';
        isValid = false;
    } else if (!user.emaiId.match(Email_Regex)) {
        message = 'Email not valid';
        isValid = false;
    } else if (!user.password) {
        message = 'Password cannot be empty';
        isValid = false;
    } else if (user.password.length < 8) {
        message = 'Password cannot be less than 8 digits long';
        isValid = false;
    }
    return {
        isValid,
        message,
    };
};

export const handleInvestorValidationSignup = (user) => {
    let isValid = true;
    let message = '';
    if (!user.name || !user.name.trim().length) {
        message = 'Full Name cannot be empty';
        isValid = false;
    } else if (user.name.length < 3) {
        message = 'Full Name too short';
        isValid = false;
    } else if (user.name.length > 30) {
        message = 'Full Name too long';
        isValid = false;
    } else if (!user.name.match(/^[A-Za-z\s]+$/)) {
        message = 'Full Name can only contain letters';
        isValid = false;
    } else if (!user.mobileNumber) {
        message = 'Contact No cannot be empty';
        isValid = false;
    } else if (user.mobileNumber.length !== 10) {
        message = 'Contact No should be 10 digits number';
        isValid = false;
    } else if (!user.mobileNumber.match(/^[0-9]+$/)) {
        message = 'Contact No can only contain digits';
        isValid = false;
    } else if (!user.emailId) {
        message = 'Email cannot be empty';
        isValid = false;
    } else if (!user.emailId.match(Email_Regex)) {
        message = 'Email not valid';
        isValid = false;
    } else if (!user.password) {
        message = 'Password cannot be empty';
        isValid = false;
    } else if (user.password.length < 8) {
        message = 'Password cannot be less than 8 characters.';
        isValid = false;
    } else if (!user.investorType || !user.investorType.trim().length) {
        message = 'Investor type cannot be empty';
        isValid = false;
    } else if (!user.organization || !user.organization.trim().length) {
        message = 'Company Name cannot be empty';
        isValid = false;
    } else if (user.organization.length < 3) {
        message = 'Company Name too short';
        isValid = false;
    } else if (user.organization.length > 150) {
        message = 'Company Name too long';
        isValid = false;
    }
    return {
        isValid,
        message,
    };
};
